


  
  

  var faDashboard = {
    prefix: 'fak',
    iconName: 'dashboard',
    icon: [
      640,
      512,
      [],
      'e00a',
      
      'M518.1 277.9c-5.1-12.4-11.4-24.3-18.8-35.5l-21.4 21.4c-8.1 8.1-21.3 8.1-29.4 0s-8.1-21.3 0-29.4l24.6-24.6c-.5-.5-1-1-1.5-1.5c-19.9-19.9-43.5-35.7-69.6-46.5c-19.6-8.1-40.2-13.3-61.2-15.3l0 32.6c0 11.5-9.3 20.8-20.8 20.8s-20.8-9.3-20.8-20.8l0-32.6c-21 2-41.7 7.2-61.2 15.3c-26 10.8-49.6 26.6-69.6 46.5l-1.2 1.2 24.9 24.9c8.1 8.1 8.1 21.3 0 29.4s-21.3 8.1-29.4 0l-21.8-21.8c-7.4 11.3-13.8 23.3-19 35.8c-5.4 13.1-9.5 26.6-12.2 40.4l143.8 0c8.6-28.6 35.2-49.3 66.5-49.3c.8 0 1.7 0 2.5 0l66.3-80.2c5-6.1 13.8-7.6 20.6-3.5s9.6 12.5 6.5 19.8L377 298.8c4.1 5.9 7.4 12.5 9.5 19.6l143.8 0c-2.7-13.8-6.8-27.4-12.2-40.4zM253.9 360l-148.3 0L64 360c0-14 1.1-27.9 3.4-41.6c3.2-19.3 8.6-38.2 16.1-56.4C96.4 231 115.2 202.7 139 179s52-42.6 83.1-55.5s64.3-19.5 98-19.5s66.9 6.6 98 19.5S477.2 155.2 501 179s42.6 52 55.5 83.1c7.5 18.2 12.9 37.1 16.1 56.4c2.3 13.7 3.4 27.6 3.4 41.6l-41.6 0-148.3 0c-9 27.9-35.2 48-66.1 48s-57.1-20.2-66.1-48zm66.1 6.4a27.9 27.9 0 1 0 0-55.8 27.9 27.9 0 1 0 0 55.8z'
      
    ]
  };

  

  
  

  var faStrategy = {
    prefix: 'fak',
    iconName: 'strategy',
    icon: [
      640,
      512,
      [],
      'e00b',
      
      'M176 150.4a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zm78.1-20.9c-8 35.8-39.9 62.5-78.1 62.5c-44.2 0-80-35.8-80-80s35.8-80 80-80c35.8 0 66.1 23.5 76.3 55.9l135.4 0C397.9 55.5 428.2 32 464 32c44.2 0 80 35.8 80 80s-35.8 80-80 80c-15.1 0-29.3-4.2-41.3-11.5L244.5 358.7c3.4 5.6 6.1 11.7 8.1 18.2l134.8 0c9.9-32.9 40.5-56.8 76.6-56.8c44.2 0 80 35.8 80 80s-35.8 80-80 80c-37.8 0-69.5-26.3-77.9-61.6l-132.3 0c-8.3 35.3-40 61.6-77.9 61.6c-44.2 0-80-35.8-80-80s35.8-80 80-80c14 0 27.1 3.6 38.5 9.8L393.8 150.5c-3.6-6.5-6.3-13.6-7.9-21l-131.8 0zM464 150.4a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8zM502.4 400a38.4 38.4 0 1 0 -76.8 0 38.4 38.4 0 1 0 76.8 0zM176 438.4a38.4 38.4 0 1 0 0-76.8 38.4 38.4 0 1 0 0 76.8z'
      
    ]
  };

  



export {

  faDashboard,
  

  faStrategy,
  

};
